import { render, staticRenderFns } from "./TrainingCoursesListFilters.vue?vue&type=template&id=6fc161b0&"
import script from "./TrainingCoursesListFilters.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCoursesListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports